/**
 * Salesforce Canvas Authentication Types
 */

export interface SalesforceRecord {
  objectAPIName: string
  recordId: string
}

export interface CanvasClient {
  oauthToken: string
  refreshToken?: string | null
  instanceId: string
  instanceUrl: string
  targetOrigin: string
}

export interface CanvasClientInfo {
  instanceUrl: string
  targetOrigin: string
}

export interface SalesforceOrganization {
  Id: string
}

export interface CustomParameters {
  bulkOpportunityIds?: string[]
  isVFPage?: boolean
  isNativeSalesforcePackage?: boolean
}

/**
 * Actions the embedded Canvas app can ask the host Salesforce page (LWC) to run
 * via `triggerAction`. Values must match the `case` labels handled in
 * labraOpportunityActionHub.js (labra-sf-app).
 */
export const SfActionType = {
  OpenSfCosell: 'open_sf_cosell',
} as const

export type SfActionType = (typeof SfActionType)[keyof typeof SfActionType]

export interface NavigateToUrlOptions {
  target?: string
  targetTabApiName?: string
  viaSalesforce?: boolean
}

export interface CanvasResizeSize {
  height?: string
  width?: string
}

export interface TokenResponse {
  accessToken: string
  tokenType: string
  expiresIn: number
  partnerId: string
  crmId: string
  roles?: string[]
  scopes?: string[]
  record?: SalesforceRecord
  organization: SalesforceOrganization
  locationUrl?: string
  canvasClient?: CanvasClientInfo
  canvasId?: string
  customParameters?: CustomParameters
}

export interface SalesforceCanvasActions {
  openModal: (url: string, label: string) => void | Promise<void>
  navigateToUrl: (url: string, options?: NavigateToUrlOptions) => Window | null
  navigateToRecord: (recordId: string, target?: string) => Window | null
  navigateBack: () => void
  refreshParent: () => void
  closeModal: () => void
  resize: (size: CanvasResizeSize) => void
  autogrow: (enabled: boolean, intervalMs?: number) => void
  triggerAction: (action: SfActionType) => void
}

export interface SalesforceContextData {
  partnerId: string
  record?: SalesforceRecord
  organization: SalesforceOrganization
  actions: SalesforceCanvasActions
  crmId: string
  scopes: string[]
  customParameters?: CustomParameters
  error?: string
  loading: boolean
  isAuthInitialized: boolean
  authError: string | null
  isInSalesforceContext: boolean
}
